/* globals */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import MainPage from '../components/MainPage';
import getDevices from '../actions/api/device/getDevices';
import getDeviceDetail from '../actions/api/device/getDeviceDetail';
import config from '../config';

const INTERVAL_TIMER = 10000;

const updateContainer = (dispatch, apiToken, role) => {
  const { searchDevice } = config.customRole.functionAccess;
  if (searchDevice.indexOf(role) !== -1) {
    dispatch(getDevices(apiToken));
  }
};

// const scrollTop = () => {
// ページネーションなどでページ更新した時にスクロールバーをトップに戻す
// const obj = document.getElementById('canDeviceScrollTable');
// obj.scrollTop = 0;
// };
class DeviceContainer extends Component {
  constructor(props) {
    super(props);
    const params = {
      dispatch: (props && props.dispatch) || null,
      showUserPrompt: props && props.showUserPrompt,
      canUpdate: !props.showUserPrompt || props.isLogin,
      apiToken: props && props.apiToken,
      role: props && props.role,
    };
    const { canUpdate, dispatch, apiToken, role } = params;
    dispatch({ type: 'CLOSE_MENU' });
    dispatch({ type: 'RESET_OPERATOR_INFO' });
    dispatch({ type: 'OPEN_DEVICE' });
    if (canUpdate) {
      updateContainer(dispatch, apiToken, role);
      this.initialTimer(params);
    }
  }

  shouldComponentUpdate(props) {
    // scrollTop();
    const params = {
      dispatch: (props && props.dispatch) || null,
      apiToken: props && props.apiToken,
      role: props && props.role,
      showUserPrompt: props && props.showUserPrompt,
      currentDeviceId: props && props.currentDeviceId,
    };
    const { dispatch, apiToken, showUserPrompt, currentDeviceId } = params;
    if (dispatch && apiToken && !showUserPrompt && currentDeviceId > 0) {
      const deviceId = currentDeviceId;
      dispatch(getDeviceDetail(apiToken, { deviceId }));
    }
    this.initialTimer(params);
    return true;
  }

  componentWillUnmount() {
    this.closeTimer();
  }

  initialTimer(params) {
    const { dispatch, apiToken, showUserPrompt, role } = params;
    this.closeTimer();
    if (dispatch && apiToken && !showUserPrompt) {
      updateContainer(dispatch, apiToken, role);
      this.mainTimer = setInterval(
        () => updateContainer(dispatch, apiToken, role),
        INTERVAL_TIMER,
      );
    }
  }

  closeTimer() {
    if (this.mainTimer !== undefined) {
      clearInterval(this.mainTimer);
      delete this.mainTimer;
    }
  }

  render() {
    const { isLogin } = this.props;
    return (!isLogin && <Redirect to="/login" />) || <MainPage />;
  }
}

DeviceContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isLogin: PropTypes.bool.isRequired,
  apiToken: PropTypes.string.isRequired,
  role: PropTypes.number.isRequired,
  showUserPrompt: PropTypes.bool.isRequired,
  currentDeviceId: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  isLogin: state.main.isLogin,
  apiToken: state.main.apiToken,
  role: state.main.userInfo.role,
  showUserPrompt: state.userPrompt.showUserPrompt,
  refreshPage: state.device.refreshPage,
  currentDeviceId: state.device.currentDeviceId,
});

export default connect(mapStateToProps)(DeviceContainer);
